<template>
  <div>
    <transition name="fade" mode="out-in">
      <p-data-table
        :headers="getHeaders()"
        :items="users"
        :search-value="searchUserByUrlParam"
        show-row-actions
        item-key="id"
      >
        <template v-slot:item.dropdown.actions="{ item }">
          <v-list flat>
            <v-subheader v-t="'Security.UserAdministration.PasswordReset'" />
            <v-list-item-group>
              <reset-password-email-dialog
                :user="item"
                :disabled="isPersisEmployee(item) || !item.email"
                :visible="!!item.email"
                :tooltip="wrongLoginProcessTooltip()"
              />
              <reset-password-dialog
                :user="item"
                :password-policies="passwordPolicies"
                :disabled="isPersisEmployee(item)"
                :visible="!item.email"
                :tooltip="wrongLoginProcessTooltip()"
              />
              <reset-password-generate-letter-dialog
                :user="item"
                :disabled="isPersisEmployee(item)"
                :visible="!item.email"
                :tooltip="wrongLoginProcessTooltip()"
              />
            </v-list-item-group>
          </v-list>
        </template>
      </p-data-table>
    </transition>
  </div>
</template>

<script>
import ResetPasswordDialog from "./components/reset-passwort-dialog";
import ResetPasswordEmailDialog from "./components/reset-passwort-email-dialog";
import GenerateLetterDialog from "./components/generate-letter-dialog";
import Users from "./graphql/UsersQuery.gql";
import PasswordPoliciesQuery from "./graphql/PasswordPoliciesQuery.gql";
import { hasManagementRole } from "@/config/keycloak/keycloakUser.js";
import { redirectIfNoAccess } from "@/config/router.js";

export default {
  beforeRouteEnter(to, from, next) {
    redirectIfNoAccess(hasManagementRole("manage-users"), next);
  },
  components: {
    "reset-password-dialog": ResetPasswordDialog,
    "reset-password-email-dialog": ResetPasswordEmailDialog,
    "reset-password-generate-letter-dialog": GenerateLetterDialog
  },
  data: () => ({
    users: [],
    searchUserByUrlParam: "",
    passwordPolicies: []
  }),
  created() {
    if (this.$route.params.firstname) {
      this.searchUserByUrlParam = atob(this.$route.params.firstname);
    }
    if (this.$route.params.lastname) {
      this.searchUserByUrlParam =
        this.searchUserByUrlParam + ", " + atob(this.$route.params.lastname);
    }
  },
  methods: {
    getHeaders() {
      return [
        {
          text: this.$t("Security.UserAdministration.UserName"),
          value: "userName"
        },
        {
          text: this.$t("Security.UserAdministration.User"),
          value: "name"
        },
        {
          text: this.$t("Security.UserAdministration.Email"),
          value: "email"
        }
      ];
    },
    isPersisEmployee(user) {
      return user && user.userType !== "Persis-Employee";
    },
    wrongLoginProcessTooltip() {
      return this.$t(
        "Security.UserAdministration.PasswordResetWrongLoginProcess"
      );
    }
  },
  apollo: {
    $client: "security",
    users: {
      query: Users,
      update({ users }) {
        if (users && users.length) {
          const requestedUsers = users.map(user => ({
            id: user.id,
            name: `${user.lastName}, ${user.firstName}`,
            email: user.email,
            userName: user.userName,
            userType: user.userType
          }));

          return requestedUsers.sort((a, b) => {
            if (a.name > b.name) return 1;
            if (b.name > a.name) return -1;
            return 0;
          });
        }
        return [];
      }
    },
    passwordPolicies: {
      query: PasswordPoliciesQuery
    }
  }
};
</script>
